export const boundTypeMap = {
    'OB': "export", // 出口
    'IB': 'import' // 进口
}

export const orderStatusMap = {
    "CONFIRMED": 'orderReceived', //已接单
    "DISPATCHED": 'dispatched', // 已派单
    "CANCELLED": 'canceled' // 已取消
}

export const taskStatusMap = {
    "NO_PICKUP": "notPickedUp",
    "PICKUP": "pickedUp",
    "DOOR_ARRIVED": "arrivedAtFactory",
    "DOOR_LEFT": "leftFactory",
    "RETURN_CONTAINER": "returnedContainer"
}